<div class="card">
  <div class="card-header p-2">
    <h4 class="card-title mb-0 mt-1">
      <a class="text-reset text-decoration-none">
        <i class="fal fa-qrcode" aria-hidden="true"></i>
        QR-Rechnung
      </a>
    </h4>
  </div>
  <div class="card-body b2-card px-2 text-center" routerLink="/qr">
    <button class="btn btn-primary">QR-Code scannen</button>
  </div>
</div>
